// Profils professionnels OFF MARKETTE — source unique, utilisée partout sur le site.
// L'ordre définit l'ordre d'affichage dans les menus déroulants. Libellés au singulier.
export const PROFILE_TYPES = [
  "Mandataire",
  "Agent",
  "Promoteur",
  "Propriétaire",
  "Particulier",
  "Marchand de biens",
  "Apporteur d'affaires",
  "Notaire",
  "Commissaire de justice",
  "Liquidateur judiciaire",
  "Autre",
];
